export default __webpack_public_path__ + "static/media/allahabad_meteorology_summary.23f3a350.png";